"use strict";

exports.__esModule = true;

exports.default = function (value) {
  return value == null;
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/yup/lib/util/isAbsent.js
// module id = 227
// module chunks = 0